import type {CheckoutProfileWrite} from '@dms/api/sales';

import {CheckoutProfileFormSchema} from '../types/CheckoutProfileFormSchema';

// Server feedback applies only while the draft parses to the same payload that was submitted.
export const getCheckoutProfileFeedbackSnapshot = (values: CheckoutProfileWrite) => {
  const parsed = CheckoutProfileFormSchema.safeParse(values);

  return parsed.success ? JSON.stringify(parsed.data) : undefined;
};
